import { render, staticRenderFns } from "./FloatingControls.vue?vue&type=template&id=03f94940"
import script from "./FloatingControls.vue?vue&type=script&lang=js"
export * from "./FloatingControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports